import { Component, inject, input, Input, OnInit } from "@angular/core";
import { TooltipDirective } from '@catch/directives';
import { ScreenService } from '@catch/services';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleQuestion } from "@fortawesome/pro-solid-svg-icons";

/**
 * Simple tooltip attached to an icon
 */
@Component({
  standalone: true,
  selector: 'ct-lib-help-tooltip',
  templateUrl: './help-tooltip.component.html',
  styleUrls: ['./help-tooltip.component.scss'],
  host: {
    '(click)': 'onClick()',
  },
  imports: [FaIconComponent, TooltipDirective],
})
export class HelpTooltipComponent {
  public screenService = inject(ScreenService);
  public readonly value = input.required<string>();
  public readonly href = input<string>();
  public readonly position = input< 'top' | 'left' | 'right' | 'bottom'>('right');
  public faCircleQuestion = faCircleQuestion;

  onClick() {
    if (this.href()) {
      window.open(this.href() ?? '', '_blank', 'noopener noreferrer');
    }
  }
}
